import { NgModule } from '@angular/core';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppLayoutModule } from './layout/app.layout.module';
import { DialogService } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { AuthInterceptor } from './auth.interceptor';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { basePropertiesInterceptor } from './base.url.interceptor';
import { TranslocoRootModule } from './transloco-root.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ToastModule } from 'primeng/toast';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CustomToastrComponent } from "./demo/components/common/custom-toastr/custom-toastr.component";
import { InputMaskModule } from 'primeng/inputmask';
import { NgxTranslateModule } from './translate.module';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
    declarations: [AppComponent],
    imports: [
    AppRoutingModule,
    AppLayoutModule,
    HttpClientModule,
    ToastModule,
    NgxTranslateModule,
    InputMaskModule,
    BrowserModule,
    BrowserAnimationsModule,
    TranslocoRootModule,
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: (HttpLoaderFactory),
            deps: [HttpClient]
        }
    }),
    CustomToastrComponent
],
    providers: [{ provide: LocationStrategy, useClass: PathLocationStrategy },
        DialogService,
        MessageService,
        
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true,
    },
    provideHttpClient(withInterceptors([basePropertiesInterceptor])),],
    bootstrap: [AppComponent],
})
export class AppModule { }
